import { useMutation } from 'urql';

import { RegisterLeadDocument } from '~src/graphql';

export const useRegisterLead = () => {
  const [{ fetching }, registerLead] = useMutation(RegisterLeadDocument);

  return { fetching, registerLead };
};
